import { render } from "./CharlaAdvantages.vue?vue&type=template&id=03e85a41&scoped=true"
import script from "./CharlaAdvantages.vue?vue&type=script&lang=js"
export * from "./CharlaAdvantages.vue?vue&type=script&lang=js"

import "./CharlaAdvantages.vue?vue&type=style&index=0&id=03e85a41&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e85a41"]])

export default __exports__